const abbreviations = [
  { term: "AC", meaning: "Alternating Current" },
  { term: "ALG", meaning: "Application Layer Gateway" },
  { term: "API", meaning: "Application Programming Interface" },
  { term: "ASCII", meaning: "American Standard Code For Information Interchange" },
  { term: "ASR", meaning: "Assessor" },
  { term: "ATP", meaning: "Automatic Train Protection" },
  { term: "C", meaning: "Current" },
  { term: "CCF", meaning: "Common-Cause Failure" },
  { term: "CCS", meaning: "Control-Command and Signalling" },
  { term: "CENELEC", meaning: "European Committee for Electrotechnical Standardisation" },
  { term: "CN", meaning: "Consist Network" },
  { term: "ComId", meaning: "Communication Identifier" },
  { term: "COP", meaning: "Code of Practice" },
  { term: "COTS", meaning: "Commercial Off-The-Shelf" },
  { term: "CRC", meaning: "Cyclic Redundancy Check" },
  { term: "CSG", meaning: "Circular Speed Gauge" },
  { term: "CST", meaning: "Consist" },
  { term: "CSTINFO", meaning: "Consist Information Telegram" },
  { term: "DC", meaning: "Direct Current" },
  { term: "DES", meaning: "Designer" },
  { term: "DNS", meaning: "Domain Name System" },
  { term: "DoS", meaning: "Denial of Service" },
  { term: "ECN", meaning: "Ethernet Consist Network" },
  { term: "ECSC", meaning: "ETB Control Service Client" },
  { term: "ECSP", meaning: "ETB Control Service Provider" },
  { term: "ED", meaning: "End Device" },
  { term: "EMC", meaning: "Electromagnetic Compatibility" },
  { term: "EMI", meaning: "Electromagnetic Interference" },
  { term: "EN", meaning: "European Standard (Europaeische Norm)" },
  { term: "ESD", meaning: "Electrostatic Discharge" },
  { term: "ETB", meaning: "Ethernet Train Backbone" },
  { term: "ETBCTRL", meaning: "ETB Control Packet" },
  { term: "ETBN", meaning: "Ethernet Train Backbone Node" },
  { term: "FC", meaning: "Fault Coverage" },
  { term: "FCS", meaning: "Frame Check Sequence" },
  { term: "FCT", meaning: "Function" },
  { term: "FET", meaning: "Field Effect Transistor" },
  { term: "FFFIS", meaning: "Form Fit Function Interface Specification" },
  { term: "FMEA", meaning: "Failure Mode and Effects Analysis" },
  { term: "FMECA", meaning: "Failure Mode, Effects and Criticality Analysis" },
  { term: "FR", meaning: "Failure Rate" },
  { term: "FRACAS", meaning: "Failure Reporting Analysis and Corrective Action System" },
  { term: "FTA", meaning: "Fault Tree Analysis" },
  { term: "H", meaning: "Hazard" },
  { term: "HR", meaning: "Highly Recommended" },
  { term: "HW", meaning: "Hardware" },
  { term: "IEC", meaning: "International Electrotechnical Commission" },
  { term: "IEEE", meaning: "Institute of Electrical and Electronics Engineers" },
  { term: "IETF", meaning: "Internet Engineering Task Force" },
  { term: "IMP", meaning: "Implementer" },
  { term: "IP", meaning: "Internet Protocol" },
  { term: "IRSE", meaning: "Institution of Railway Signal Engineers" },
  { term: "ISO", meaning: "International Standards Organisation" },
  { term: "LAD", meaning: "Logistic and Administrative Delay" },
  { term: "LCC", meaning: "Life Cycle Cost" },
  { term: "M", meaning: "Mandatory" },
  { term: "MAC", meaning: "Medium Access Control" },
  { term: "MC", meaning: "Multicast" },
  { term: "MD", meaning: "Message Data" },
  { term: "MD-PDU", meaning: "Message Data Protocol Data Unit" },
  { term: "MDT", meaning: "Mean Down Time" },
  { term: "MIB", meaning: "Management Information Base" },
  { term: "MTBF", meaning: "Mean Time Between Failures" },
  { term: "MTBM", meaning: "Mean Time Between Maintenances" },
  { term: "MTTF", meaning: "Mean Time To Failure" },
  { term: "MTU", meaning: "Maximal Transmission Unit" },
  { term: "MUT", meaning: "Mean Up Time" },
  { term: "MVB", meaning: "Multifunction Vehicle Bus" },
  { term: "NAT", meaning: "Network Address Translation" },
  { term: "NR", meaning: "Not Recommended" },
  { term: "OID", meaning: "Object Identifier" },
  { term: "OMTS", meaning: "Onboard Multimedia and Telematic Subsystems" },
  { term: "OSI", meaning: "Open System Interconnection" },
  { term: "PD", meaning: "Process Data" },
  { term: "PD-PDU", meaning: "Process Data Protocol Data Unit" },
  { term: "PICS", meaning: "Protocol Implementation Conformance Statement" },
  { term: "PM", meaning: "Project Manager" },
  { term: "PROP", meaning: "Properties" },
  { term: "QoS", meaning: "Quality of Service" },
  { term: "R", meaning: "Recommended" },
  { term: "RAC", meaning: "Risk Acceptance Criteria" },
  { term: "RAM", meaning: "Reliability, Availability and Maintainability" },
  { term: "RAMS", meaning: "Reliability, Availability, Maintainability and Safety" },
  { term: "RC", meaning: "Repair Coverage" },
  { term: "RFC", meaning: "Request For Comments" },
  { term: "RQM", meaning: "Requirements Manager" },
  { term: "SCR", meaning: "Silicon Controlled Rectifier" },
  { term: "SDR", meaning: "Safe Down Rate" },
  { term: "SDSINK", meaning: "Safe Data Sink" },
  { term: "SDSRC", meaning: "Safe Data Source" },
  { term: "SDT", meaning: "Safe Down Time" },
  { term: "SDT", meaning: "Safe Data Transmission" },
  { term: "SID", meaning: "Source IDentifier (for Safe Communication)" },
  { term: "SIL", meaning: "Safety Integrity Level" },
  { term: "SMI", meaning: "Safe Message Identifier" },
  { term: "SNMP", meaning: "Simple Network Management Protocol" },
  { term: "SRAC", meaning: "Safety Related Application Condition" },
  { term: "SSC", meaning: "Safety Sequence Counter" },
  { term: "STC", meaning: "Safe Topography Counter" },
  { term: "SW", meaning: "Software" },
  { term: "TCMS", meaning: "Train Control and Monitoring System" },
  { term: "TCN", meaning: "Train Communication Network" },
  { term: "TCP", meaning: "Transmission Control Protocol" },
  { term: "TDS", meaning: "Train Display System" },
  { term: "TFFR", meaning: "Tolerable Functional Failure Rate" },
  { term: "THR", meaning: "Tolerable Hazard Rate" },
  { term: "TRDP", meaning: "Train Real Time Data Protocol" },
  { term: "TSI", meaning: "Technical Specification for Interoperability" },
  { term: "TSS&TP", meaning: "Test Suite Structure and Test Purpose" },
  { term: "TST", meaning: "Tester" },
  { term: "TTDB", meaning: "Train Topology Database" },
  { term: "TTDP", meaning: "Train Topology Discovery Protocol" },
  { term: "TTL", meaning: "Time To Live" },
  { term: "UDP", meaning: "User Datagram Protocol" },
  { term: "UIC", meaning: "International Union of Railways" },
  { term: "UML", meaning: "Unified Modeling Language" },
  { term: "URI", meaning: "Uniform Resource Identifier" },
  { term: "URL", meaning: "Uniform Resource Locator" },
  { term: "UUID", meaning: "Universally Unique Identifier" },
  { term: "UuT", meaning: "Unit Under Test" },
  { term: "V&V", meaning: "Verification and Validation" },
  { term: "VAL", meaning: "Validator" },
  { term: "VDP", meaning: "Vital Data Packet" },
  { term: "VDR", meaning: "Voltage-Dependent Resistor" },
  { term: "VER", meaning: "Verifier" },
  { term: "VLAN", meaning: "Virtual Local Area Network" },
  { term: "WTB", meaning: "Wire Train Bus" },
  { term: "XML", meaning: "Extensible Markup Language" },
  { term: "XSD", meaning: "XML Schema Definition" }
];
const sortedAbbreviations = [...abbreviations].sort((left, right) => (
  left.term.localeCompare(right.term, undefined, { numeric: true, sensitivity: "base" })
));

export default function Abbreviations() {
  const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "var(--bs-table-bg, #f8f9fa)"
  };

  const getRowStyle = (index) => ({
    "--bs-table-bg": index % 2 === 0 ? "rgba(25, 135, 84, 0.06)" : "#ffffff"
  });

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center gap-3 mb-3 flex-wrap">
        <div>
          <h3 className="mb-1">Abbreviations</h3>
          <div className="text-muted">
            Common project roles, recommendation levels, and railway software terms.
          </div>
        </div>

        <span className="badge text-bg-secondary">
          Total: {sortedAbbreviations.length}
        </span>
      </div>

      <table className="table table-hover align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th style={{ ...stickyHeaderStyle, width: "180px" }}>Abbreviation</th>
            <th style={stickyHeaderStyle}>Meaning</th>
          </tr>
        </thead>

        <tbody>
          {sortedAbbreviations.map((item, index) => (
            <tr key={`${item.term}-${item.meaning}`} style={getRowStyle(index)}>
              <td className="fw-semibold">{item.term}</td>
              <td>{item.meaning}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
